import React, { useState } from 'react'
import Checkbox from 'components/Checkbox/checkbox'
import {
  Preview,
  Section,
  Row,
  Col,
} from 'component-catalog/previews/PreviewKit'

export function CheckboxMock(): React.ReactElement {
  const [checked, setChecked] = useState(false)

  return (
    <Preview>
      <Section label="Interactive">
        <Row>
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span className="text-sm text-fg">
            {checked ? 'Checked' : 'Unchecked'}
          </span>
        </Row>
      </Section>

      <Section label="Sizes">
        <Col>
          <Row label="sm">
            <Checkbox boxSize="sm" checked readOnly />
            <Checkbox boxSize="sm" checked={false} readOnly />
          </Row>
          <Row label="md (default)">
            <Checkbox checked readOnly />
            <Checkbox checked={false} readOnly />
          </Row>
          <Row label="lg">
            <Checkbox boxSize="lg" checked readOnly />
            <Checkbox boxSize="lg" checked={false} readOnly />
          </Row>
        </Col>
      </Section>

      <Section label="States (md size)">
        <Col>
          <Row label="Checked">
            <Checkbox checked readOnly />
          </Row>
          <Row label="Unchecked">
            <Checkbox checked={false} readOnly />
          </Row>
          <Row label="Disabled checked">
            <Checkbox checked disabled readOnly />
          </Row>
          <Row label="Disabled unchecked">
            <Checkbox checked={false} disabled readOnly />
          </Row>
        </Col>
      </Section>
    </Preview>
  )
}
